import isObject from "modules/isObject";

export default (getState = () => {}) =>
  (action = {}) => {
    if (isObject(action)) return Object.assign(action, { state: getState() });

    return action;
  };
